import { useCallback, useEffect, useState } from 'react';

import { USER_SESSION_URL } from '../constants';

type SavedRedirectURLHookResult = [string | undefined, () => void];

export const useSavedRedirectURL = (): SavedRedirectURLHookResult => {
  const [url, setURL] = useState('');

  useEffect(() => {
    setURL(localStorage.getItem(USER_SESSION_URL) || '');
  }, []);

  const clear = useCallback(() => {
    setURL('');
    localStorage.removeItem(USER_SESSION_URL);
  }, []);

  return [url, clear];
};
